import { model } from "core/util";
import { PensionStatementSettings as PensionStatementSettingsType, PensionStatementSettingsDto } from "types";

export const PensionStatementSettings = model.createModel<PensionStatementSettingsDto, PensionStatementSettingsType>((json) => ({
    receiveStatement: json.ReceiveStatement,
    statementPeriodicity: json.StatementPeriodicity,
    lastSendDate: json.LastSendDate,
}));
